import { useContext, useMemo } from 'react'

import { CheckoutNavigationBarOptionsContext } from '../../../layouts/context'

const useCheckoutNavBarOptionValue = (
  label: string,
): { loading: boolean; navBarOptionValue: number } => {
  const { navigationBarOptions, loading } = useContext(CheckoutNavigationBarOptionsContext)

  const navBarOption = useMemo(
    () => navigationBarOptions.find((option) => option.label === label),
    [label, navigationBarOptions],
  )
  const navBarOptionValue = navBarOption ? navBarOption.value : 0

  return { loading, navBarOptionValue }
}

export default useCheckoutNavBarOptionValue
